<template>
  <div class="container">
    <div class="bgc">
      <img src="https://p1.ssl.qhimg.com/t01250be999ff6d9dba.jpg" alt="" />
    </div>
    <div class="guest">
      <div class="guestBox" v-for="(item, index) in allGuestObj" :key="index">
        <h2>{{ item.title }}</h2>
        <ul class="guestBoxList">
          <li class="listItem" v-for="(subItem, subIndex) in item.user_list" :key="subIndex">
            <div class="listItemBox">
              <p class="avatar">
                <img :src="subItem.avatar" alt="" class="photo" />
              </p>
              <p class="name">{{ subItem.name }}</p>
              <p class="company">
                <span class="detail" v-for="(i, j) in subItem.title" :key="j">
                  {{ i }}
                  <span v-if="j !== subItem.title.length - 1">,</span>
                </span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { getAllGuest } from '@/api/2023/index.js'

const allGuestObj = ref([]) // 所有嘉宾数据

const getInfo = () => {
  getAllGuest()
    .then((res) => {
      allGuestObj.value = res.data.data.list
    })
    .catch(() => {})
}

onBeforeMount(async () => {
  await getInfo()
})
</script>

<style lang="scss" scoped>
.container {
  .bgc {
    img {
      width: 100%;
    }
  }
  .guest {
    width: 95%;
    min-height: 723px;
    padding-bottom: 18px;
    margin-top: 27px;
    &Box {
      margin-top: 27px;
      padding-left: 18px;
      h2 {
        font-weight: 700;
      }
      &List {
        margin-top: 9px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .listItem {
          list-style: none;
          margin: 0 4.5px;
          &Box {
            width: 136px;
            text-align: center;
            display: inline-block;
            margin-top: 18px;
            .avatar {
              background: url(https://p5.ssl.qhimg.com/t01247583781d87facf.png) no-repeat;
              background-size: 100% 100%;
              width: 108px;
              height: 108px;
              display: inline-block;
              padding-top: 3px;

              border-radius: 50%;
              overflow: hidden;
              .photo {
                width: 102px;
                border-radius: 50%;
              }
            }
            .name {
              font-weight: 700;
              color: #363c59;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-bottom: 9px;
              margin-top: 7px;
              width: 100%;
              overflow: hidden;
              font-size: 11px;
              text-align: center;
            }
            .company {
              font-size: 11px;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>
